module.exports = __webpack_public_path__ + "media/images/athletes/2593-f4fa05c01ebd8938c04853a580548d34.png";